<template>

    <div class="accordion__collection" >

        <h2 class="sidebar__tag" v-if="collection"><a href="#" @click.prevent="toggleExpand" class="button-collapse-primary" :class="{'button-collapse': isExpanded, 'active': isExpanded || isActive }">{{ collection.title }}</a></h2>


        <template v-if="isExpanded">
            <div v-if="isLoading || isExpanding" key="accordion__loading" class="accordion__loading">
                <loading :alt="true" :mini="true" ></loading>
            </div>
            <div class="accordion__content" key="accordion__content" v-else>
                <slot></slot>
            </div>
        </template>

    </div>

</template>


<script>

import Timeline from 'js/admin/components/sidebar/Timeline.vue'

export default {
    components: { Timeline },
    props: {
        collection: {
            type: Object,
            /*
            {
                id: 1,
                title: 'Collection title',
            }
            */
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
        isExpanding: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        toggleExpand: function() {
            const event = this.isExpanded ? 'collapse' : 'expand'
            this.$emit(event, this.collection)
        }
    }
}
</script>



<style lang="scss">

    @import 'global';

    .accordion__collection {
        padding-top: 2px;
        width: 100%;
    }

    .accordion__content, .accordion__loading {
        opacity: 1;
        animation: reveal 0.7s cubic-bezier(0.31, 0.000, 0.36, 1.000);
    }

    .accordion__loading {
        height: 220px;
        position: relative;

        animation-delay: 0.3s;
        animation-fill-mode: backwards;
    }

</style>



// WEBPACK FOOTER //
// Collection.vue?0bede27f